import { computed, onMounted, ref } from 'vue';
import { usePermittedMembers } from '@/entities/User';

export function useMemberFilterOptions() {
  const { userOptions, isLoading, fetchUsers } = usePermittedMembers({
    includeInactiveMembers: true,
  });
  const searchQuery = ref('');

  const options = computed(() => {
    const query = searchQuery.value.trim().toLowerCase();
    return userOptions.value
      .filter((member) => !query || member.name.toLowerCase().includes(query))
      .map((member) => ({ value: String(member.id), label: member.name }));
  });

  onMounted(() => {
    void fetchUsers();
  });

  return { options, isLoading, searchQuery };
}
